/** @format */

import {PaymentsContext, paymentsDefaultState} from './payments_context';
import React, {useState, useEffect, useContext} from 'react';
import {useFetch} from 'frontier-utilities';

export const PaymentsProvider = ({children}) => {
    const [state, setState] = useState(paymentsDefaultState);

    const {isLoading, fetchData: handleGetPaymentProfiles} = useFetch(
        '/account/users/get-payment-profiles',
        res => {
            setState(prevState => ({
                ...prevState,
                paymentProfiles: res,
                loading: false,
                error: null
            }));
        }
    );

    function removeProfileById(id) {
        setState(prevState => ({
            ...prevState,
            paymentProfiles: prevState.paymentProfiles.filter(profile => profile.id !== id)
        }));
    }

    return (
        <PaymentsContext.Provider
            value={{
                state: {...state, loading: isLoading},
                handleGetPaymentProfiles,
                removeProfileById
            }}>
            {children}
        </PaymentsContext.Provider>
    );
};

export const usePaymentsContext = () => {
    const context = useContext(PaymentsContext);
    if (!context) {
        throw new Error('usePaymentsContext must be used within a PaymentsProvider');
    }
    return context;
};
